import { ApiEvent } from 'owa-addins-events/lib/schema/ApiEvent';
import {
    defaultEventRegistrationHandler,
    defaultEventUnregistrationHandler,
    defaultEventOnTriggerHandler,
} from 'owa-addins-events/lib/events/defaultEventHandlers';

export default function getAttachmentsChangedEvent(): ApiEvent {
    return {
        register: defaultEventRegistrationHandler,
        unregister: defaultEventUnregistrationHandler,
        onTrigger: defaultEventOnTriggerHandler,
        formatArgsForHandler,
    };
}

function formatArgsForHandler(args: any): any {
    return [JSON.stringify(args)];
}
